module.exports = [{"_id":"egyszarnyu-ajto","name":{"de":"Einflügelige Tür","en":"sliding glass door","hu":"egyszárnyú ajtó"}},{"_id":"sotet-konyha","name":{"de":"Dunkle Küche","en":"dark kitchen","hu":"sötét konyha"}}]


//////////////////
// WEBPACK FOOTER
// ./static/data/constructor-templates.json
// module id = 962
// module chunks = 0